import { color as echartsColor } from 'echarts/core';

/** Same hue with the given alpha; falls back to the opaque colour if ECharts cannot parse it. */
export function toTranslucentColor(color: string, opacity: number): string {
  return echartsColor.modifyAlpha(color, opacity) ?? color;
}
